<template>
    <div class="content_div">
        <el-card>
            <!--商品-->
            <el-form :inline="true" :model="query" class="demo-form-inline" STYLE="margin-bottom: 20px;">
                <el-form-item label="姓名" clearable>
                    <el-input class="input_class" v-model="query.nickName" auto-complete="off" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" clearable>
                    <el-input class="input_class" v-model="query.nickName" auto-complete="off" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
                <el-button type="success" @click="btnInsert(null,0)">新增</el-button>
            </el-form>

            <el-table
                :data="dataList"
                border>
                <el-table-column type="index" label="编号" width="80"/>
                <!--                <el-table-column prop="coverUrl" label="头像" width="130px">-->
                <!--                    <template slot-scope="scope">-->
                <!--                        <el-image :src="filePre+scope.row.avatar" style="width: 100px; height: 100px"/>-->
                <!--                    </template>-->
                <!--                </el-table-column>-->
                <el-table-column prop="username" label="登陆名"/>
                <el-table-column prop="phone" label="手机号"/>
                <el-table-column prop="nickname" label="姓名"/>
                <el-table-column prop="createTime" label="创建时间"/>
                <el-table-column align="center" label="操作" width="210">
                    <template slot-scope="scope">
                        <el-button size="small" type="info" @click="btnInsert(scope.row,2)">修改</el-button>
                        <el-button size="small" type="danger" @click="btnDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top:10px;"
                           background
                           layout="total,prev, pager, next"
                           @current-change="currentChange"
                           :total="total">
            </el-pagination>

        </el-card>

        <el-dialog :close-on-click-modal="false" title="操作" :visible="isShowDialogFlag" @close="close" width="30%">
            <el-form label-width="120px" :model="data" ref="data" :rules="rules">
                <el-form-item label="登陆名" prop="username">
                    <el-input maxLength="20" v-model="data.username" maxlength="20" auto-complete="off" placeholder="请输入登陆名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input maxlength="11" v-model="data.phone" auto-complete="off" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="nickname">
                    <el-input maxlength="20" v-model="data.nickname" auto-complete="off" placeholder="请输入姓名"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click='close'>取消</el-button>
                <el-button type="primary" class="title" @click="submitForm('data')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import global from "@/api/global";
import {reqDeleteSysUsersById, reqInsertSysUsers, reqListSysUsers, reqUpdateSysUsers} from "@/api/core/Person";


const userType = 1;
export default {
    name: "User",
    async created() {
        await this.load();
    },
    methods: {
        async load() {
            this.dataList = [];
            let data = await reqListSysUsers(this.query);
            this.dataList = data.records;
            this.total = data.total;
        },
        btnInsert(row, type) {
            if (type === 0) {
                this.data = {};
            } else if (type === 1) {
                this.data = {};
            } else {
                this.data = JSON.parse(JSON.stringify(row));
            }
            this.isShowDialogFlag = true;
        },
        async close() {
            this.isShowDialogFlag = false;
        },
        currentChange(num) {
            this.query.currentPage = num;
            this.load();
        },
        async submitForm(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    this.data.type = userType;
                    let result = !this.data.id ? await reqInsertSysUsers(this.data) : await reqUpdateSysUsers(this.data);
                    this.$message.success("操作成功");
                    await this.close();
                    await this.load();
                }
            })
        },
        async btnDelete(id) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await reqDeleteSysUsersById({id: id});
                this.$message.success("操作成功");
                this.query.currentPage = 1
                await this.load();
            });
        },

    },
    data() {
        return {
            total: 0,
            dataList: [],
            query: {
                currentPage: 1,
                pageSize: 10,
                type: userType,
            },
            isShowDialogFlag: false,
            filePre: global.preview_path_url,
            data: {
                id: null,
            },
            rules: {
                username: [
                    {required: true, message: '请输入用户名', trigger: 'blur'},
                ],
                nickname: [
                    {required: true, message: '请输入昵称', trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                ]
            },
        }
    },
}
</script>
